var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9928 4.80005C8.01839 4.80005 4.79999 8.02565 4.79999 12C4.79999 15.9744 8.01839 19.2 11.9928 19.2C15.9744 19.2 19.2 15.9744 19.2 12C19.2 8.02565 15.9744 4.80005 11.9928 4.80005ZM12 17.76C8.81759 17.76 6.23999 15.1824 6.23999 12C6.23999 8.81765 8.81759 6.24005 12 6.24005C15.1824 6.24005 17.76 8.81765 17.76 12C17.76 15.1824 15.1824 17.76 12 17.76ZM11.28 8.40005H12.36V12.18L15.6 14.1024L15.06 14.988L11.28 12.72V8.40005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.45f496ce4f45d0f644ed6cea842d846b.svg";
export { ForwardRef as ReactComponent };